@if (label) {
<label for="{{id}}" class="block text-lg text-grey-300 font-medium mb-1" [ngClass]="labelClass">
  {{label}}
  <span class="text-sm text-grey-500">
    {{secondaryLabel}}
  </span>
</label>
}

@if (searchable) {
<div class="relative">
  <button
    #trigger
    type="button"
    [ngClass]="inputClass"
    class="w-full flex items-center justify-between gap-2 px-3 py-2 border border-grey-800 bg-transparent rounded-md text-left focus:outline-none focus:ring-2 focus:ring-primary disabled:bg-[#EDEDED] disabled:opacity-50"
    [disabled]="control.disabled"
    (click)="toggleOpen()"
  >
    <span class="truncate" [ngClass]="selectedLabel ? '' : 'text-grey-500'">{{ selectedLabel || placeholder }}</span>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="shrink-0" [class.rotate-180]="isOpen">
      <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  @if (isOpen) {
  <div
    class="fixed z-50 rounded-md border border-grey-800 bg-white shadow-lg"
    [style.top.px]="dropdownPosition.top"
    [style.left.px]="dropdownPosition.left"
    [style.width.px]="dropdownPosition.width"
  >
    <div class="p-2 border-b border-grey-100">
      <input
        type="text"
        [(ngModel)]="searchTerm"
        [ngModelOptions]="{ standalone: true }"
        placeholder="Search..."
        autocomplete="off"
        class="w-full px-2 py-1.5 text-sm border border-grey-800 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
      />
    </div>
    <ul class="max-h-56 overflow-y-auto py-1">
      @for (option of filteredOptions; track $index) {
      <li
        class="px-3 py-2 text-sm cursor-pointer hover:bg-grey-100"
        (click)="selectOption(option)"
      >
        {{ option[displayName] }}
      </li>
      } @empty {
      <li class="px-3 py-2 text-sm text-grey-500">No results found</li>
      }
    </ul>
  </div>
  }
</div>
} @else {
<select [formControl]="control" [ngClass]="inputClass"
  class="w-full px-3 py-2 border border-grey-800 placeholder-grey-800 bg-transparent rounded-md focus:outline-none focus:ring-2 focus:ring-primary disabled:bg-[#EDEDED] disabled:opacity-50">
  <option [value]="defaultValue" disabled selected>{{ placeholder }}</option>
  @for (option of options; track $index) {
  @if (getObject) {
  <option [ngValue]="option">{{ option[displayName] }}</option>
  } @else {
  <option [ngValue]="option[value]">{{ option[displayName] }}</option>
  }
  }
</select>
}


@if (useDefaultError && ((control.touched || control.dirty) && control.invalid)) {
<p class="text-red-500 text-xs mt-1">
  {{errorMessage}}
</p>
}